import { apiClient } from './client';
import type { NodePublic } from './workspace';

/**
 * 메일 첨부를 내 워크스페이스로 담기 (2026-09-02).
 *
 * `chat-attachment-save.ts` 의 메일판이다. 워크스페이스의 복사 API 를 그냥 쓰지 못하는 이유도
 * 같다 — 그쪽 권한 판정은 워크스페이스 기준이라 **남이 보낸 메일의 첨부는 '없는 파일'** 이
 * 된다. 받는 사람은 내려받을 수 있는데 담을 수는 없는 비대칭이 생기므로, 권한을 메일 기준으로
 * 보는 창구를 따로 둔다(복사 자체는 서버가 같은 함수로 처리한다 — 쿼터·되돌리기가 두 벌로
 * 갈라지지 않는다).
 *
 * `parentId` 를 생략하면 내 워크스페이스 맨 위에 담긴다.
 */
export async function saveMailAttachmentToWorkspace(
  mailId: string,
  fileId: string,
  input: { parentId?: string | null; name?: string } = {},
): Promise<NodePublic> {
  const { data } = await apiClient.post<{ file: NodePublic }>(
    `/mail/messages/${mailId}/attachments/${fileId}/save-to-workspace`,
    input,
  );
  return data.file;
}
